<div class="deleteConfirmation">
  @if (!isDeleting) {
    <div>
      <p-button severity="danger" size="small" type="button" styleClass="btn-xs" (onClick)="startDelete()" label="{{ button_disp }}"></p-button>
    </div>
  }
  @if (isDeleting) {
    <div>
      @if (explainMessage) {
        <div>
          <div class="form-group row">
            <label for="message" class="col-form-label"><b>Please Explain Why: </b></label>
            <textarea type="text" id="message" class="form-control" [ngModelOptions]="{ standalone: true }" [(ngModel)]="message"> </textarea>
          </div>
          <div class="form-check row" style="float: right">
            <input id="sendmail" type="checkbox" class="form-check-input" [ngModelOptions]="{ standalone: true }" [(ngModel)]="sendmail" />
            <label for="sendmail" class="form-check-label"><b>Send Mail </b></label>
          </div>
        </div>
      }
      <div class="form-group row">
        <p-button severity="secondary" size="small" type="button" styleClass="  btn-xs" (onClick)="cancel()" label="Abort deletion"></p-button>
        <p-button severity="danger" size="small" type="button" styleClass="  btn-xs" (onClick)="confirm()" label="Confirm"></p-button>
      </div>
    </div>
  }
</div>
